import { Box, Button, Flex } from '@chakra-ui/react'
import React from 'react'
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikControl from '../../components/form-components/FormikControl';
import axios from 'axios';

export default function CsvExport() {
  const key_options = [
    { key: 3, value: "Teacher" },
    { key: 4, value: "Honors Or Masters Student" },
    { key: 5, value: "Mphil Or Phd Student" },
    { key: 6, value: "Officer" },
    { key: 7, value: "Staff" },
    { key: 8, value: "Evening Course" },
  ];

  const initialValues = {
    user_type: '',
    start_date: '',
    end_date: ''
  };

  const validataionSchema = Yup.object({
    user_type: Yup.string().required("Required"),
    start_date: Yup.string().required("Required"),
    end_date: Yup.string().required("Required"),
  });

  function downloadCSV(csv, filename) {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function convertToCSV(data) {
    if (data.length === 0) {
      alert('No data found');
      return '';
    }
    const headers = Object.keys(data[0]).join(',');
    const rows = data.map(row =>
      Object.values(row).map(val =>
        typeof val === 'string' && val.includes(',')
          ? `"${val}"`
          : val
      ).join(',')
    );

    return [headers, ...rows].join('\n');
  }

  const onSubmit = async (values) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/csv-data-fetch`, {
      params: values
    });

    if (data.results) {
      const csv = convertToCSV(data.results.csvData);
      downloadCSV(csv, `csv_data_${values.user_type}_${values.start_date}_${values.end_date}.csv`);
    }
  };

  return (
    <Box bg={"white"} p={6}>
      <Formik
        initialValues={initialValues}
        validationSchema={validataionSchema}
        onSubmit={onSubmit}
      >
        {
          formik => (
            <Form>
              <FormikControl required={true} control='radio' label='User Type' name='user_type' options={key_options} />
              <Flex gap={5}>
                <FormikControl placeholder={'Enter Start Date'} required={true} control='date' type='date' label='Start Date' name='start_date' />
                <FormikControl placeholder={'Enter End Date'} required={true} control='date' type='date' label='End Date' name='end_date' />
              </Flex>

              <Button mt={2} colorScheme="teal" variant={"solid"} type="submit">Export CSV</Button>
            </Form>
          )
        }
      </Formik>
    </Box>
  )
}
